"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentChangeNotificationSchema = void 0;
exports.ContentChangeNotificationSchema = {
    "$id": "https://www.redbull.com/schemas/change-notifications/content.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentChangeNotification",
    "description": "Change notification sent out when a content resource is changed",
    "type": "object",
    "properties": {
        "data": {
            "description": "The data field contains the content resource that has been changed. For details, see https://api.developers.redbull.com/docs/resource-change-notifications#content-resource-changes",
            "type": "object",
            "oneOf": [
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/type-groups/content.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/type-groups/master.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/featuring-bundles.schema.json"
                }
            ]
        },
        "meta": {
            "description": "The meta field contains the change event meta data. For details, see https://api.developers.redbull.com/docs/resource-change-notifications#content-resource-changes",
            "type": "object",
            "properties": {
                "contentManagementVersion": {
                    "description": "The contentManagementVersion field contains the version of the content management system that has sent the change notification.",
                    "type": "string"
                },
                "fieldsUpdated": {
                    "description": "The fieldsUpdated field contains the fields that have been changed. It will not include anything for events that describe a resource creation.",
                    "type": "object",
                    "properties": {
                        "attributes": {
                            "description": "Contains the names of attributes that have been changed.",
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "relationships": {
                            "description": "Contains the names of relationships that have been changed.",
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        },
                        "meta": {
                            "description": "Contains the names of meta fields that have been changed.",
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    },
                    "required": [
                        "attributes",
                        "relationships",
                        "meta"
                    ],
                    "additionalProperties": false
                },
                "messageAction": {
                    "description": "The action field contains the operation leading to the content resource change.",
                    "type": "string",
                    "enum": [
                        "CREATED",
                        "UPDATED",
                        "DELETED"
                    ]
                },
                "eventType": {
                    "const": "change-notification:content"
                }
            },
            "additionalProperties": false,
            "required": [
                "messageAction"
            ]
        }
    },
    "additionalProperties": false,
    "required": [
        "data",
        "meta"
    ]
};
//# sourceMappingURL=data:application/json;base64,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